<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>User Login Activity</h3>
      <p>Latest logins (latest first)</p>
    </header>

    <div class="tab-head login-filter-bar">
      <div class="login-actions">
        <div class="login-filters">
          <label class="filter-label"><strong>Organization</strong></label>
          <select [(ngModel)]="selectedOrgId" (change)="onOrganizationChange()">
            <option value="">All</option>
            <option *ngFor="let org of organizations" [value]="org.id">{{ org.name }}</option>
          </select>
        </div>
        <button class="export-button" (click)="refresh()">Refresh</button>
      </div>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Username</th>
            <th>Organization</th>
            <th>Role</th>
            <th>Last Login</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="5">Loading login activity...</td>
          </tr>
          <tr *ngFor="let entry of entries; let i = index">
            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
            <td>{{ entry.username }}</td>
            <td>{{ entry.organization || '-' }}</td>
            <td>{{ entry.role || '-' }}</td>
            <td>{{ entry.last_login ? (entry.last_login | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>
          </tr>
          <tr *ngIf="!loading && entries.length === 0">
            <td colspan="5">No login activity found.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <div class="total-records">Total Records: {{ totalRecords }}</div>
      <div class="pagination-controls">
        <label for="recordsPerPage">Records per page </label>
        <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
            <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
        </select>
        <span>{{ currentPage }} / {{ totalPages }}</span>
        <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
          ‹
        </button>
        <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
          ›
        </button>
      </div>
    </div>
  </div>
</div>
